import { LEAN_BLOCKS, BOARD_TYPES, BUSINESS_ROUTE_PATH } from './constants';
import { BMC_BLOCKS } from '../common_components/bmc/bmc_constants';

function isLeanBlock(block) {
  return (block == LEAN_BLOCKS.MEASURE || block == LEAN_BLOCKS.LEARN || block == LEAN_BLOCKS.BUILD);
}


function isValidBoardType(type) {
  return boardTypesArray().includes(type);
}

const boardTypesArray = () => [
  BOARD_TYPES.VISION,
  BOARD_TYPES.CURRENT_BMC,
];


function showImageInNewWindow(src, e) {
  e.preventDefault();
  e.stopPropagation();
  window.open(src);
}


const businessBlocksArray = () => [...Object.values(BMC_BLOCKS), ...Object.values(LEAN_BLOCKS)];

export {
  isLeanBlock, isValidBoardType, boardTypesArray, showImageInNewWindow, businessBlocksArray
};
